import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageCircle } from 'lucide-react';
import { bookingPrefetchHandlers } from '@/utils/prefetchBooking';

const texts = {
  en: 'BOOK NOW',
  pt: 'RESERVAR',
  es: 'RESERVAR',
  de: 'JETZT BUCHEN',
  fr: 'RÉSERVER',
};

const whatsappCopy = {
  en: 'Hi! I\'m interested in booking at Quinta da Arrábida and would love to know more.',
  pt: 'Olá! Estou interessado em reservar na Quinta da Arrábida e gostava de saber mais.',
  es: 'Hola! Me interesa reservar en Quinta da Arrábida y me gustaría saber más.',
  de: 'Hallo! Ich interessiere mich für eine Buchung in der Quinta da Arrábida.',
  fr: 'Bonjour ! Je suis intéressé(e) par une réservation à la Quinta da Arrábida.',
};

const WHATSAPP_NUMBER = '351934876934';

export const MobileBookBar = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const lang = i18n.language?.split('-')[0]?.split('@')[0] || 'en';
  const label = texts[lang] || texts.en;
  const waText = whatsappCopy[lang] || whatsappCopy.en;
  const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(waText)}`;

  // Hide on checkout, confirmation, admin and any /book/* subroute
  const path = location.pathname;
  const hidden =
    ['/checkout', '/confirmation', '/qapanel', '/_stories'].some(p => path.includes(p)) ||
    path === '/book' ||
    /^\/book\/[^/]+/.test(path);
  if (hidden) return null;

  const handleWhatsAppClick = () => {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'whatsapp_click', {
          event_category: 'lead',
          event_label: 'mobile_book_bar',
        });
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'whatsapp_mobile_cta');
      }
    } catch { /* noop */ }
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden flex shadow-[0_-2px_10px_rgba(0,0,0,0.12)]"
      data-testid="mobile-book-bar"
    >
      {/* WhatsApp — fast lane for hesitant users */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleWhatsAppClick}
        className="flex items-center justify-center bg-[#25D366] text-white active:bg-[#1da851] transition-colors"
        style={{
          width: '70px',
          paddingTop: '18px',
          paddingBottom: 'calc(18px + env(safe-area-inset-bottom, 10px))',
          flexShrink: 0,
        }}
        aria-label="Chat on WhatsApp"
        data-testid="mobile-whatsapp-btn"
      >
        <MessageCircle size={22} strokeWidth={2} />
      </a>

      {/* Primary CTA */}
      <Link
        to="/book"
        {...bookingPrefetchHandlers()}
        className="flex-1 flex items-center justify-center bg-[#33685F] text-white font-serif text-[15px] tracking-[0.2em] uppercase transition-colors active:bg-[#264f48]"
        style={{
          paddingTop: '18px',
          paddingBottom: 'calc(18px + env(safe-area-inset-bottom, 10px))',
        }}
        data-testid="mobile-book-btn"
      >
        {label}
      </Link>
    </div>
  );
};
